import { useState, useRef, useEffect } from 'react';
import { color, space, fontSize, lineHeight, borderRadius, shadow } from '@ifixit/primitives';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons';

type AccordionProps = {
   title?: string;
   subtitle?: string;
   children: any;
   className?: any;
};

const Header = styled.button<{ $open: boolean }>`
   display: flex;
   align-items: center;
   padding: ${space[4]} ${space[5]};
   cursor: pointer;
   line-height: ${lineHeight.tight};
   border: none;
   background-color: ${color.white};

   div:first-of-type {
      flex-grow: 1;
      margin: 0 ${space[4]};
      font-weight: bold;
      font-size: ${fontSize.lg};
      color: ${color.gray[800]};
      text-align: left;
   }

   div:last-of-type {
      font-size: ${fontSize.md};
      color: ${color.gray[500]};
      text-align: right;
   }

   svg {
      overflow: visible;
      color: ${color.gray[500]};
      transition: transform 0.2s ease;
      ${props => props.$open && 'transform: rotate(90deg)'};
   }

   &:focus {
      outline: none;
   }
`;

const Content = styled.div<{ $height: number }>`
   max-height: ${props => props.$height}px;
   overflow: auto;
   transition: max-height 0.2s ease;
`;

const Accordion = ({ title, subtitle, children, className }: AccordionProps) => {
   const [open, setOpen] = useState(false);

   const content = useRef(null);
   const [contentHeight, setContentHeight] = useState(null);

   useEffect(() => {
      const onResize = () => {
         // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
         setContentHeight(content.current.scrollHeight);
      };
      onResize();

      window.addEventListener('resize', onResize);

      return () => {
         window.removeEventListener('resize', onResize);
      };
   }, []);

   return (
      <div className={className}>
         <Header onClick={() => setOpen(open => !open)} $open={open}>
            <FontAwesomeIcon icon={faCaretRight} />
            <div>{title}</div>
            <div>{subtitle}</div>
         </Header>
         {/* @ts-expect-error TS(2769) FIXME: No overload matches this call. */}
         <Content ref={content} $height={open ? contentHeight : 0}>
            {children}
         </Content>
      </div>
   );
};

const StyledAccordion = styled(Accordion)`
   display: flex;
   flex-direction: column;
   font-style: normal;
   border-radius: ${borderRadius.md};
   box-shadow: ${shadow[0]};
   background: ${color.white};
   overflow: hidden;
`;

export default StyledAccordion;
